import { ListItemProps } from '@silverfort/sf-components/dist/ListItem';

export const LastAccessOptions: Array<ListItemProps<number>> = [
    { title: 'Last 24 hours', value: 1 },
    { title: 'Last week', value: 7 },
    { title: 'Last 30 days', value: 30 },
    { title: 'Last 90 days', value: 90 },
    { title: 'Last 180 days', value: 180 },
    { title: 'Last 360 days', value: 360 }
];
